import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-[55%] h-full hidden md:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-background-50/50 to-background-50"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="w-full lg:w-[52%] flex flex-col items-start">
            <span className="inline-block px-3 py-1.5 text-xs md:text-sm font-medium text-primary-700 bg-primary-100/80 rounded-full mb-4 md:mb-5 whitespace-nowrap">
              {heroData.tagline}
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              {heroData.h1}
            </h1>

            <p className="mt-3 md:mt-4 text-sm md:text-base text-foreground-600 font-medium italic">
              — {heroData.slogan}
            </p>

            <div className="mt-5 md:mt-6 space-y-2 md:space-y-2.5">
              {heroData.description.map((paragraph, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-6 md:mt-7 flex flex-wrap items-center gap-4 md:gap-6">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                    {stat.label}
                  </span>
                  {i < heroData.stats.length - 1 && (
                    <span className="w-px h-5 bg-background-300 hidden md:block ml-2"></span>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleNavClick(e, heroData.primaryCta.href)}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 md:px-8 md:py-3.5 text-sm md:text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleNavClick(e, heroData.secondaryCta.href)}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 md:px-8 md:py-3.5 text-sm md:text-base font-semibold text-foreground-700 bg-background-100 hover:bg-background-200 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[48%] flex items-center justify-center">
            <div className="relative w-[240px] h-[380px] md:w-[280px] md:h-[440px] lg:w-[300px] lg:h-[470px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20colorful%20Korean%20manhwa%20webtoon%20on%20screen%2C%20vertical%20scrolling%20comic%20style%2C%20warm%20vibrant%20illustration%2C%20clean%20phone%20mockup%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20background&width=640&height=960&seq=hero-main-visual&orientation=portrait"
                alt="亲亲漫画APP阅读界面展示 - 高清韩漫下拉式阅读体验"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 w-16 h-16 md:w-20 md:h-20 bg-accent-500 rounded-2xl flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-2xl md:text-3xl"></i>
              </div>
              <div className="absolute -top-3 -left-3 md:-top-4 md:-left-4 px-3 py-1.5 md:px-4 md:py-2 bg-background-50 rounded-lg text-xs md:text-sm font-semibold text-primary-600 whitespace-nowrap">
                韩漫·日漫·国漫
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}